export function normalizeGiftRecipientAddress(address: string): string {
  const trimmed = address.trim()
  const toastStylePrefix = /^\d+\s+packs sent to\s+/i

  if (toastStylePrefix.test(trimmed)) {
    return trimmed.replace(toastStylePrefix, "").trim()
  }

  return trimmed
}

export function truncateSolanaAddress(address: string): string {
  const normalized = normalizeGiftRecipientAddress(address)

  if (normalized.length <= 12) {
    return normalized
  }

  return `${normalized.slice(0, 4)}...${normalized.slice(-4)}`
}
